"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontColor = exports.text = exports.solid = exports.outline = exports.link = exports.gradient = void 0;

// funcao calcula a cor da fonte baseado na cor de fundo do botao
var fontColor = function fontColor(hexa) {
  var hexa2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  hexa = hexa.replace('#', '');
  var rgb = hexa.match(/.{1,2}/g);
  var rgbInt = [];
  rgb.map(function (cores, key) {
    rgbInt[key] = parseInt(cores, 16);
    return null;
  }); // grayscale => R = 0.30 G = 0.59 B = 0.11

  var scale = rgbInt[0] * 0.3 + rgbInt[1] * 0.59 + rgbInt[2] * 0.11;

  if (hexa2) {
    hexa2 = hexa2.replace('#', '');

    var _rgb = hexa2.match(/.{1,2}/g);

    _rgb.map(function (cores, key) {
      rgbInt[key] = parseInt(cores, 16);
      return null;
    });

    var scale2 = rgbInt[0] * 0.3 + rgbInt[1] * 0.59 + rgbInt[2] * 0.11;
    scale = (scale + scale2) / 2;
  }

  var color = '#FFFFFF';

  if (scale > 127) {
    color = '#1e232c';
  }

  return color;
}; // funcao retorna o hover do botao


exports.fontColor = fontColor;

var setHover = function setHover(color, colors) {
  var rgbInt = [];
  var hexa = color.replace('#', '');
  var rgb = hexa.match(/.{1,2}/g);
  rgb.map(function (cores, key) {
    rgbInt[key] = parseInt(cores, 16);
    return null;
  });
  var colorKeys = Object.keys(colors);
  var colorName = Object.keys(colors).find(function (key) {
    return colors[key] === color;
  });
  var colorIndex = colorKeys.indexOf(colorName); // grayscale => R = 0.30 G = 0.59 B = 0.11

  var scale = rgbInt[0] * 0.3 + rgbInt[1] * 0.59 + rgbInt[2] * 0.11;

  if (scale > 127) {
    return {
      background: colors[colorKeys[colorIndex + 1]],
      textColor: fontColor(colors[colorKeys[colorIndex + 1]]),
      borderColor: 'transparent'
    };
  }

  return {
    background: colors[colorKeys[colorIndex - 1]],
    textColor: fontColor(colors[colorKeys[colorIndex + 1]]),
    borderColor: 'transparent'
  };
}; // funcao retorna o hover do botao


var setFontColor = function setFontColor(color, colors) {
  var rgbInt = [];
  var hexa = color.replace('#', '');
  var rgb = hexa.match(/.{1,2}/g);
  rgb.map(function (cores, key) {
    rgbInt[key] = parseInt(cores, 16);
    return null;
  });
  var colorKeys = Object.keys(colors);
  var colorName = Object.keys(colors).find(function (key) {
    return colors[key] === color;
  });
  var colorIndex = colorKeys.indexOf(colorName); // grayscale => R = 0.30 G = 0.59 B = 0.11

  var scale = rgbInt[0] * 0.3 + rgbInt[1] * 0.59 + rgbInt[2] * 0.11;

  if (scale > 127.5) {
    return colors[colorKeys[colorIndex + 3]];
  }

  return colors[colorKeys[colorIndex - 3]];
}; // funcao retorna RGB em string para css de uma cor em hexa


var setRgb = function setRgb(hexa) {
  hexa = hexa.replace('#', '');
  var rgb = hexa.match(/.{1,2}/g);
  rgb = rgb.map(function (cRgb) {
    cRgb = parseInt(cRgb, 16);
    return cRgb;
  });
  return "".concat(rgb[0], ", ").concat(rgb[1], ", ").concat(rgb[2]);
}; // retorna as cores do Button Solid


var solid = function solid(color, colors) {
  var background = colors[color] || colors.primary;
  var textColor = fontColor(background);
  var rgb = setRgb(background);
  var borderColor = 'transparent';
  var hover = setHover(background, colors);
  return {
    background: background,
    textColor: textColor,
    borderColor: borderColor,
    rgb: rgb,
    hover: hover
  };
}; // retorna as cores do Button Outline


exports.solid = solid;

var outline = function outline(color, colors) {
  var background = 'transparent';
  var textColor = colors[color] || colors.primary;
  var rgb = setRgb(textColor);
  var borderColor = textColor;
  var hover = {
    background: textColor,
    textColor: fontColor(textColor),
    borderColor: 'transparent'
  };
  return {
    background: background,
    textColor: textColor,
    borderColor: borderColor,
    rgb: rgb,
    hover: hover
  };
}; // retorna as cores do Button Outline


exports.outline = outline;

var text = function text(color, colors) {
  var background = 'transparent';
  var textColor = colors[color] || colors.primary;
  var rgb = setRgb(textColor);
  var borderColor = 'transparent';
  var hover = {
    background: 'rgba(0,0,0,0.05)',
    textColor: textColor,
    borderColor: 'transparent'
  };
  return {
    background: background,
    textColor: textColor,
    borderColor: borderColor,
    rgb: rgb,
    hover: hover
  };
}; // retorna as cores do Button Outline


exports.text = text;

var link = function link(color, colors) {
  var background = 'transparent';
  var textColor = colors[color] || colors.primary;
  var rgb = setRgb(textColor);
  var borderColor = 'transparent';
  var hover = {
    background: 'transparent',
    textColor: setFontColor(textColor, colors),
    borderColor: 'transparent'
  };
  return {
    background: background,
    textColor: textColor,
    borderColor: borderColor,
    rgb: rgb,
    hover: hover
  };
};

exports.link = link;

var gradient = function gradient(myGradient, gradients) {
  var colors = gradients[myGradient] || gradients.gradient1;
  var textColor = fontColor(colors.c1, colors.c2);
  var rgb = setRgb(colors.c1);
  var background = "linear-gradient(53deg, ".concat(colors.c1, ", ").concat(colors.c2, " ").concat(colors.c3 ? ", ".concat(colors.c3) : "", ")");
  var borderColor = 'none';
  var hover = {
    background: "linear-gradient(106deg, ".concat(colors.c1, ", ").concat(colors.c2, " ").concat(colors.c3 ? ", ".concat(colors.c3) : "", ")"),
    textColor: textColor,
    borderColor: 'transparent'
  };
  return {
    background: background,
    textColor: textColor,
    borderColor: borderColor,
    rgb: rgb,
    hover: hover
  };
};

exports.gradient = gradient;